






































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import * as rules from '@/modules/shared/shared/domain/rules';

@Component({
    components: {},
})

// TODO: change the name of the item
export default class Tape extends Vue {
    @Prop()
    isFormComplete!: number;

    tape: {
        giveOrTake: string;
        code: string;
    } = {
        giveOrTake: '',
        code: '',
    };

    rules: any = rules;

    @Watch('isFormComplete')
    sendData(value: boolean, oldValue: boolean) {
        // TODO: change the name of the data being emmited
        this.$emit('receiveData', this.tape);
    }
}
